const comments = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20portrait%20avatar%20with%20warm%20lighting%20on%20neutral%20background%2C%20professional%20headshot%20style%2C%20clean%20composition&width=120&height=120&seq=avatar-01-mv&orientation=squarish',
    rating: 5,
    text: '一直用蘑菇影视看4K电影，画质真的没话说，而且真的没有广告！之前在其他平台看几分钟就弹广告，体验极差。蘑菇影视让我找回了纯粹看电影的快乐，强烈推荐给所有影迷朋友。',
    time: '2小时前',
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20portrait%20avatar%20with%20soft%20studio%20lighting%2C%20professional%20headshot%2C%20neutral%20background%2C%20clean%20style&width=120&height=120&seq=avatar-02-mv&orientation=squarish',
    rating: 5,
    text: '自从发现蘑菇影视，再也不用到处找资源了。蓝光画质的电视剧追起来太过瘾了，更新也很及时，热门韩剧基本同步更新。关键是播放超流畅，我家网速一般也完全不卡顿。',
    time: '5小时前',
  },
  {
    name: '电影夜猫子',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20portrait%20avatar%20with%20warm%20ambient%20light%2C%20professional%20headshot%2C%20neutral%20background%2C%20simple%20composition&width=120&height=120&seq=avatar-03-mv&orientation=squarish',
    rating: 5,
    text: '蘑菇影视的纪录片库太丰富了！作为一个纪录片爱好者，在这里找到了很多BBC和国家地理的高清纪录片资源，4K画质加上流畅播放，每一帧都是视觉享受。',
    time: '1天前',
  },
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20portrait%20avatar%20with%20gentle%20studio%20light%2C%20professional%20headshot%20style%2C%20neutral%20background%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-04-mv&orientation=squarish',
    rating: 4,
    text: '手机上用蘑菇影视看剧太方便了，界面简洁好操作。晚上躺床上用手机看超清画质的剧集，没有广告打断剧情节奏，一口气刷完一整季，太爽了！希望动漫资源再丰富一些。',
    time: '2天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">观众热评</h2>
          <p className="mt-3 text-sm text-foreground-500">来自真实观众的观影分享</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-500">{c.time}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`text-xs ${j < c.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}